import * as React from "react"
import BtnSumate from "./BtnSumate"
import TitleAnimate from "./TitleAnimate";
import { SkySec } from "./BgAnimation";
import ScrollAnimation from "./ScrollAnimation";

export default ({ backImage, textBanner, textDescription, componentsAnimated, newBanner }: any) => {
    return (
        <div className={`page__banner ${newBanner == 1 ? 'page__newBanner' : ''}`}>
            <SkySec desk={{ url: backImage.desk }} mobile={{ url: backImage.mobile }} />
            {componentsAnimated && componentsAnimated.map((animated: any, indexAnimate: number) => <React.Fragment key={indexAnimate}>{animated}</React.Fragment>)}
            <div className="page__banner-title">
                <h1><TitleAnimate text={textBanner} /></h1>
                {textDescription && <p className="page__banner-description" dangerouslySetInnerHTML={{ __html: textDescription }} data-aos='fade-up' data-aos-delay='2000'></p>}
            </div>
            <div className="page__banner-sumate">
                {/*{textBanner && <BtnSumate />}*/}
            </div>
            {textBanner && <ScrollAnimation delay={2500} />}
        </div>
    )
}
